import React from 'react'
import {
  Result,
  ScoresWrapper,
  Board,
  TrainWrapper,
  Train,
} from './ElementsStyles'
import Background from './Background'
import { ReactComponent as TrainLost } from '../../../../lib/assets/trainLost.svg'
import { ReactComponent as TrainWin } from '../../../../lib/assets/trainWin.svg'
import { ReactComponent as TrainHistory } from '../../../../lib/assets/trainHistory.svg'
export default function Scores() {
  const train = [
    {
      content: '22.00',
      down: '1',
      bg: 'green',
    },
    {
      content: '45.00',
      down: '1',
      bg: 'green',
    },
    {
      content: '70.00',
      down: '1',
      bg: 'grey',
    },
    {
      content: '81.00',
      down: '0',
      bg: 'green',
    },
    {
      content: '98.00',
      down: '0',
      bg: 'green',
    },
    {
      content: '34.00',
      down: '0',
      bg: 'grey',
    },
  ]

  return (
    <ScoresWrapper>
      <Background />
      <Board>
        <Result res>
          <span>Roll under</span>
          <p>84.00</p>
        </Result>
        <Result>
          <span>CyberScore</span>
          <p>34.00</p>
        </Result>
      </Board>
      <TrainWrapper>
        <Train down={'0'} className='history'>
          <TrainHistory />
          <p>Game History</p>
          <div className='gradient' />
        </Train>
        {train.map((i: any, id: number) => (
          <Train key={id} down={i.down}>
            {i.bg === 'green' ? <TrainWin /> : <TrainLost />}
            <p>{i.content}</p>
          </Train>
        ))}
      </TrainWrapper>
    </ScoresWrapper>
  )
}
